export enum NotificationFormMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view'
};

export const isDateValid = (date: Date) => {
  return !Number.isNaN(date.getTime());
};
